/**
 * Integrations Hub.
 *
 * Third-party service connections and data import/export management
 * in a focused tabbed interface.
 */

import { Link } from "react-router-dom";
import { Globe, Upload, ArrowLeft } from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import IntegrationsPage from "@/pages/IntegrationsPage";
import DataImportPage from "@/pages/DataImportPage";

const tabs = [
  { key: "integrations", label: "Integrations", icon: Globe },
  { key: "import", label: "Import / Export", icon: Upload },
];

function AdminIntegrationsHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "integrations");

  return (
    <div className="page-content space-y-6">
      <div className="flex items-start gap-4">
        <Link
          to="/admin"
          className="mt-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)] transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h2 className="text-2xl font-bold text-[var(--text-primary)]">
            Integrations
          </h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Connect to third-party services and manage data import/export.
          </p>
        </div>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "integrations" && <IntegrationsPage />}
      {activeTab === "import" && <DataImportPage />}
    </div>
  );
}

export default AdminIntegrationsHub;
